import AcceptBusinessUserInvitation from './AcceptBusinessUserInvitation';
export default AcceptBusinessUserInvitation;
